import { useState, useEffect, useRef } from "react";
import { Box, Alert, AlertTitle, Collapse, Link } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "src/hooks/useAuth";
import useSocket from "src/hooks/useSocket";

function WhatsAppDisconnectedAlert() {
  const { user } = useAuth();
  const { socket } = useSocket();
  const navigate = useNavigate();
  const location = useLocation();
  const [instanceConnected, setInstanceConnected] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const prevUserIdRef = useRef(null);

  // Sincroniza instanceConnected com o objeto do usuário e reseta dismissed a cada novo login
  useEffect(() => {
    if (user?.id !== prevUserIdRef.current) {
      prevUserIdRef.current = user?.id ?? null;
      setDismissed(false);
      setInstanceConnected(user?.instanceConnected !== false);
    }
  }, [user?.id, user?.instanceConnected]);

  // Escuta eventos de socket para atualização em tempo real
  useEffect(() => {
    if (!socket || !user?.id) return;

    const onConnect = () => socket.emit("join-room", user.id);
    const onInstanceConnection = ({ instanceConnected: connected }) => {
      setInstanceConnected(connected);
      try {
        const stored = JSON.parse(localStorage.getItem("user"));
        if (stored) {
          localStorage.setItem(
            "user",
            JSON.stringify({ ...stored, instanceConnected: connected })
          );
        }
      } catch (_) {}
    };

    socket.on("connect", onConnect);
    socket.on("instanceConnection", onInstanceConnection);

    if (socket.connected) {
      socket.emit("join-room", user.id);
    }

    return () => {
      socket.off("connect", onConnect);
      socket.off("instanceConnection", onInstanceConnection);
    };
  }, [socket, user?.id]);

  const isMuralDisplayRoute = /\/mural(?!-config)/.test(location.pathname);
  const shouldShow = !isMuralDisplayRoute && (user?.api === "Youon" || user?.api === "Baileys LTS") && !instanceConnected && !dismissed;

  return (
    <Collapse in={shouldShow} unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          top: 16,
          right: 16,
          zIndex: 9999,
          maxWidth: 400,
          width: "calc(100vw - 32px)",
        }}
      >
        <Alert
          severity="warning"
          onClose={() => setDismissed(true)}
          sx={{
            boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
            backgroundColor: "rgba(32, 31, 31, 0.97)",
            color: "#b1ac9d",
            "& .MuiAlert-icon": { color: "#ffb74d" },
            "& .MuiAlertTitle-root": { color: "#b1ac9d" },
            "& .MuiIconButton-root": { color: "#fff" },
          }}
        >
          <AlertTitle sx={{ fontWeight: 700 }}>
            Conexão com WhatsApp interrompida
          </AlertTitle>
          A conexão com o WhatsApp foi interrompida.{" "}
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate("/contentChat")}
            sx={{
              fontWeight: 700,
              verticalAlign: "baseline",
              color: "#ffb74d",
              textDecorationColor: "#ffb74d",
            }}
          >
            Clique aqui
          </Link>{" "}
          e faça o pareamento novamente para não ficar sem interatividade.
        </Alert>
      </Box>
    </Collapse>
  );
}

export default WhatsAppDisconnectedAlert;
